var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCameraIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 23,
    viewBox: "0 0 25 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.10912 0.960501C8.50916 0.360433 9.18264 0 9.90383 0H14.7473C15.4685 0 16.142 0.360433 16.542 0.960501L18.2754 3.56046C18.3325 3.64618 18.4287 3.69767 18.5317 3.69767H22.4942C23.6855 3.69767 24.6512 4.66339 24.6512 5.85465V20.0291C24.6512 21.2203 23.6855 22.186 22.4942 22.186H2.15698C0.965711 22.186 0 21.2203 0 20.0291V5.85465C0 4.66339 0.965711 3.69767 2.15698 3.69767H6.11942C6.22245 3.69767 6.31866 3.64618 6.37581 3.56046L8.10912 0.960501ZM12.3256 7.39535C9.94305 7.39535 8.01163 9.32677 8.01163 11.7093C8.01163 14.0918 9.94305 16.0233 12.3256 16.0233C14.7081 16.0233 16.6395 14.0918 16.6395 11.7093C16.6395 9.32677 14.7081 7.39535 12.3256 7.39535Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIcon);
export default __webpack_public_path__ + "static/media/camera-icon.af9e074c30e34fa52fa3e7a5a2e3d285.svg";
export { ForwardRef as ReactComponent };